import moment from "moment";

export const dateFormatter = (e:any) => {
  if (e.value === undefined || e.value === '' || e.value === null) {
    return 'N/A'
  }
  return moment(e.value).format('DD/MM/YYYY')
};